import React from "react";
import styled from "styled-components";
import { useTheme } from "@material-ui/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import numeral from "numeral";
import {
  XYPlot,
  XAxis,
  VerticalGridLines,
  GradientDefs,
  AreaSeries,
  ChartLabel
} from "react-vis";

const Wrapper = styled.div`
  width: ${props => props.width}px;
`;

const tickLabel = ({ value }) => (
  <tspan>
    <tspan x="0" dy="1em" style={{ fontSize: 18, fontWeight: 700 }}>
      {value ? numeral(value).format("$0,0") : "See Dealer"}
    </tspan>
  </tspan>
);

const BellCurveGraph = ({
  values,
  ...props
}) => {
  const [poorTradeInValue, fairTradeInValue, goodTradeInValue] = values;
  const theme = useTheme();

  const formatTicks = v => {
    switch (v) {
      case 10:
        if (!poorTradeInValue) {
          return "See Dealer";
        }
        return tickLabel({ value: poorTradeInValue, title: "Poor Condition" });
      case 50:
        return tickLabel({ value: fairTradeInValue, title: "Fair Condition" });
      case 80:
        return tickLabel({ value: goodTradeInValue, title: "Good Condition" });
      default:
        return "See dealer";
    }
  };
  const smallDevice = useMediaQuery(theme.breakpoints.down("sm"));

  const labelStyle = {
    fontWeight: 700,
    fontFamily: 'Roboto, "Helvetica", "Arial", sans-serif'
  };

  const labelProps = smallDevice
    ? { yPercent: 1.18, includeMargin: false }
    : { yPercent: 1.13, includeMargin: false };

  return (
    <Wrapper {...props}>
      <XYPlot
        width={props.width}
        height={props.width / 2}
        style={{ marginLeft: -15 }}
      >
        <GradientDefs>
          <linearGradient id="CoolGradient">
            <stop offset="0%" stopColor="red" stopOpacity={0.4} />
            <stop offset="25%" stopColor="yellow" stopOpacity={0.4} />
            <stop offset="50%" stopColor="green" stopOpacity={0.3} />
          </linearGradient>
        </GradientDefs>
        <VerticalGridLines
          style={{ color: "black" }}
          tickValues={[10, 50, 80]}
        />
        <AreaSeries
          data={[
            { x: 0, y: 0 },
            { x: 20, y: 20 },
            { x: 50, y: 100 },
            { x: 80, y: 20 },
            { x: 100, y: 0 }
          ]}
          color="url(#CoolGradient)"
          curve={"curveCatmullRom"}
        />
        <XAxis
          tickValues={[10, 50, 80]}
          tickFormat={formatTicks}
          tickSize={10}
          style={{
            text: {
              fontFamily: 'Roboto, "Helvetica", "Arial", sans-serif'
            }
          }}
        />
        <ChartLabel
          text="Below Average Condition"
          xPercent={-0.02}
          {...labelProps}
          style={{ textLength: smallDevice ? 110 : 135, ...labelStyle }}
        />
        <ChartLabel
          text={"Average Condition"}
          xPercent={smallDevice ? 0.37 : 0.4}
          {...labelProps}
          style={{ textLength: smallDevice ? 90 : 100, ...labelStyle }}
        />
        <ChartLabel
          text="Excellent Condition"
          xPercent={0.7}
          {...labelProps}
          style={{ textLength: smallDevice ? 90 : 100, ...labelStyle }}
        />
      </XYPlot>
    </Wrapper>
  );
};

export default React.memo(BellCurveGraph);
